import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import React, { FC, useRef, useState } from "react";
import { Color } from "../../models/door_configuration";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { NullableNumber, NullableString } from "../../core/common_types";
import rals from "../../assets/rals.json";
import { useFormik } from "formik";

function getRals(skipRals: string[]) {
    return rals.filter(r => !skipRals.includes(r.RAL));
}

export type RalColorsProps = {
    skipRals?: string[],
    onConfirm: (value: NullableString) => void,
}

export const RalColorsDialog: FC<{data: RalColorsProps, onConfirm: (value: NullableString) => void, onCancel: () => void}> = (props) => {    
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("xl"));
    const [filteredRals, setFilteredRals] = useState(getRals(props.data.skipRals ?? []));
    const searchDebounceRef = useRef<NodeJS.Timeout|null>(null);
    const formik = useFormik<{searchText: string}>({
        initialValues: {
            searchText: ""
        },
        onSubmit: data => {
            if (searchDebounceRef.current) {
                clearTimeout(searchDebounceRef.current);
                searchDebounceRef.current = null;
            }
    
            searchDebounceRef.current = setTimeout(() => {
                if (data.searchText) {
                    setFilteredRals(getRals(props.data.skipRals ?? []).filter(r => 
                        r.RAL.toLowerCase().includes(data.searchText.toLocaleLowerCase()) || 
                        r.Italian.toLowerCase().includes(data.searchText.toLocaleLowerCase()) || 
                        r.English.toLowerCase().includes(data.searchText.toLocaleLowerCase())
                    ));
                } else {
                    setFilteredRals(getRals(props.data.skipRals ?? []));
                }
            }, 1000);
        }
    });

    const setValueAndClose = (ral: NullableString) => {
        props.onConfirm(ral);
    }
    const hasRalColors = getRals(props.data.skipRals ?? []).length > 0;
    return (
        <Dialog fullWidth={false} fullScreen={fullScreen} maxWidth="xl" onClose={props.onCancel} open={true}>
            <DialogTitle>
            <div className="row">
                    <div className="col-xl-4">
                        Colori disponibili
                    </div>
                    <div className="col-xl-4">
                        <TextField
                            fullWidth 
                            size="small"
                            value={formik.values.searchText}
                            placeholder="digita un codice o un colore per la ricerca rapida..."
                            onChange={e => {
                                formik.setFieldValue("searchText", e.target.value);
                                formik.submitForm();
                            }}
                        />
                    </div>
                    <div className="col-xl-4">
                        
                    </div>
                </div>                
            </DialogTitle>
            <DialogContent className="py-2">
                {formik.values.searchText && filteredRals.length === 0 ? (
                    <div className="text-center my-5">
                        <h6 className="text-muted">Colore non disponibile per questo campo</h6>
                    </div>
                ) : (
                    <div className="row dialog-colors-grid my-0">
                        {filteredRals
                            .sort((a, b) => a.Italian.localeCompare(b.Italian))
                            .map((ral) => (
                                <div
                                    key={ral.RAL}
                                    className="col-xl-2 p-2 dialog-colors-grid-item d-flex flex-column align-items-center"
                                    onClick={() => setValueAndClose(ral.RAL)}
                                >
                                    <div style={{ width: "4rem", height: "4rem", backgroundColor: ral.HEX }}></div>
                                    <div className="p-2 text-center">
                                        <h6 className="text-secondary mb-0">{ral.Italian}</h6>
                                        <small className="badge bg-light text-dark">RAL {ral.RAL}</small>
                                    </div>
                                </div>
                            ))}
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button color="secondary" onClick={props.onCancel}>Annulla</Button>
            </DialogActions>
        </Dialog>
    );
}